import styled from '@emotion/styled';
import { Colors } from '../../../styles/variables/colors';
import { Breakpoints } from '../../../styles/variables/breakpoints';

const { tableHeader } = Colors;
const { sm, lg } = Breakpoints;

type Props = {
    flexStart: boolean;
};

export const OuterDiv = styled.div`
    padding: 0 24px;
    font-weight: 600;
    font-size: 15px;
    background-color: ${tableHeader};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    min-width: 100%;
    width: fit-content;
    box-sizing: border-box;

    @media (max-width: ${lg}) {
        padding: 0 16px;
    }

    @media (max-width: ${sm}) {
        display: none;
    }
`;

export const InnerDiv = styled.div<Props>`
    display: ${({ flexStart }) => (flexStart ? 'inline-flex' : 'flex')};
    flex-direction: row;
    justify-content: ${({ flexStart }) => (flexStart ? 'flex-start' : 'space-between')};
    align-items: center;
    padding: 16px 0;
    box-sizing: border-box;
    width: ${({ flexStart }) => (flexStart ? 'max-content' : '100%')};

    @media (max-width: ${sm}) {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px 0 12px;
    }
`;
